import { pick } from 'lodash'

const transformToUpdateDictionaryWordArgs = data =>
  pick(data, ['languageId', 'term'])

export default transformToUpdateDictionaryWordArgs
